import { AppPartType } from "@lhd/features/Apps/AppForm/types";
import { getConfigAppPartType } from "@lhd/features/Apps/utils";

interface IProps {
  isDisabled?: boolean;
  preview?: boolean;
  item: AppPartType;
  parentItem?: AppPartType;
  style?: React.CSSProperties;
  isTable?: boolean;
  nameItem?: string;
  children?: React.ReactNode;
  styleColor?: React.CSSProperties;
}

const AutoFill = (props: IProps) => {
  const {
    item,
    isDisabled,
    preview,
    isTable,
    children,
    styleColor = {},
  } = props;
  const { isHiddenLabel, labelText } = getConfigAppPartType(item);
  const isShowOnlyValue = !preview && isTable && isDisabled;

  return (
    <>
      {isHiddenLabel ? (
        ""
      ) : (
        <label
          className="ant-form-item-required ant-form-item-label"
          style={{
            padding: "4px 0 4px",
            display: "block",
          }}
        >
          {labelText}
        </label>
      )}
      <div
        className="auto-filled"
        style={
          isShowOnlyValue
            ? {
                paddingLeft: "2px",
              }
            : {
                background: "#fff",
                height: "44px",
                border: "1px solid #d9d9d9",
                padding: "10px",
                color: "black",
                ...styleColor,
              }
        }
      >
        {children || "(自動入力)"}
      </div>
    </>
  );
};

export default AutoFill;
